import { Component, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-editor-modal',
  templateUrl: './image-editor-modal.component.html',
  styleUrls: ['./image-editor-modal.component.scss']
})
export class ImageEditorModalComponent implements OnInit {

  @Input() image = '';
  @Output() imageChange = new EventEmitter();
  loading = false;
  @ViewChild('content', { static: true }) content; 

  constructor(private modalService: NgbModal) {}

  ngOnInit(){}

  open() {
    this.modalService.open(this.content, {backdrop: "static", windowClass: 'modal-fullscreen', ariaLabelledBy: 'Modal edição laudo'}).result
    .then((r) => {}).catch(e => {});
  }

  close(modal) {
    modal.close();
  }

  save(imageEditor) {
    imageEditor.crop();
  }

  saveImage(image, modal) {
    this.loading = true;
    this.image = image;
    this.imageChange.emit(this.image);
    modal.close();
  }
}
